import noop from 'lodash/noop';
import React from 'react';
import { ButtonType } from '../../Buttons/Button/ButtonType';
import SvgSearch from '@img/icons/search.svg';
import S from './Filters.styles';
const Filters = ({ filters, filterValue, itemAmount = 1, pageIndex = 1, pageSize = 9, sortByOptions, sortByValue, totalItems, onFilterChange, onSortChange = noop, onSubmitFilter = noop, }) => {
    const firstNum = itemAmount < 1 ? 0 : (pageSize * pageIndex) - (pageSize - 1);
    const secondNum = ((pageSize * pageIndex) - (pageSize - 1)) + (itemAmount - 1);
    return (React.createElement(S.Container, null,
        filters.length > 0 &&
            React.createElement(S.FilterTop, null,
                React.createElement(S.SelectLabel, { htmlFor: 'nameSearch' }, "Filter by name"),
                React.createElement(S.FilterSearch, { id: "nameSearch", placeholder: 'Search By Name', value: filterValue && filterValue['nameSearch'], onChange: (event) => (onFilterChange('nameSearch', event.target.value, true, false)), onKeyDown: (event) => {
                        if (event.key !== 'Enter') {
                            return;
                        }
                        onSubmitFilter();
                    } }),
                filters.map((filter) => (React.createElement(S.FilterHolder, { key: filter.key }, filter.options.length > 0 && (React.createElement(S.Filter, null,
                    React.createElement(S.SelectLabel, { htmlFor: filter.key },
                        "Filter by ",
                        filter.title),
                    React.createElement(S.FilterDropdown, { id: filter.key, name: filter.key, value: filterValue && filterValue[filter.key], onChange: (event) => (onFilterChange(filter.key, event.target.value, true, false)) },
                        React.createElement("option", { value: "" }, filter.title),
                        filter.options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text))))))))),
                React.createElement(S.FilterSearchBtn, { buttonType: ButtonType.Default, onClick: () => onSubmitFilter(), icon: React.createElement(SvgSearch, null) }, "Search")),
        React.createElement(S.FilterBase, null,
            React.createElement(S.PageIndex, null,
                React.createElement("strong", null,
                    firstNum,
                    " - ",
                    secondNum),
                " of ",
                React.createElement("strong", null, totalItems),
                " Results"),
            sortByOptions && (React.createElement(S.Filter, null,
                React.createElement(S.SelectLabel, { htmlFor: "sortBy" }, "Sort results by"),
                React.createElement(S.FilterDropdown, { id: "sortBy", name: "sortBy", value: sortByValue, onChange: (event) => onSortChange(event.target.value) },
                    React.createElement("option", { value: "" }, "Sort By"),
                    sortByOptions.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text)))))))));
};
export default Filters;
